import * as React from 'react';
import { Button, Checkbox, TextField, Box } from "@mui/material";
import { CAETable, Row } from "@cae/component-library";
import { useCurrentUser, usePermissions,useRoles,useUsers } from '@cae/component-library';
import { EditButton } from 'Components';
import { Item, Serial, SnaiV } from 'Models';
import { useSnaiV } from 'Hooks';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
// import { ExcelExport } from 'Components/ExcelExport';
import { useTranslation } from 'react-i18next';
// import { History } from 'Helpers';
import { useNavigate } from "react-router-dom";
import { baseURL } from 'Pages';

export interface SNAIState {
    snaiV: SnaiV[];
}
export const SNAI: React.FC = () => {
    const {permissions} = usePermissions(14);
    const {roles} = useRoles(14);
    const {users } = useUsers();    
    const { t } = useTranslation("snaiV");
    const { id } = useParams<{ id: string }>();
    const { snaiV, setSnaiV, serials, setSerials, isLoading } = useSnaiV(Number(id)|| 0);
    const Navigate = useNavigate();
    
    const isAdmin: boolean = (permissions.find(p => p.roleId === roles.find(r => r.name === "Admin")?.id)) != null;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const [projectNumberSearch, setProjectNumberSearch] = React.useState<String>(id|| "");
    const handleRefresh = (rowData: SnaiV, item: Item, newSerial: Serial[]) => {
        const tempSnaiV = _.cloneDeep(snaiV);
        const originalSerials = _.cloneDeep(serials);
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].isHott = item.isHott;
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].isPo = item.isPo;
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].updatedBy = item.updatedBy;
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].updatedByName = `${users.find(u=>u.userId === item.updatedBy)?.firstName} ${users.find(u=>u.userId === item.updatedBy)?.lastName}`;
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].serialNumbers = '';
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].serialNumbers = newSerial.filter(e=>e.isActive).map((e) => {
            if(e.serialDate instanceof Date)
                return e.serialNumber + ' ' + e.serialDate.getDate()+' '+months[e.serialDate.getMonth()]+' '+e.serialDate.getFullYear()
            else if(e.serialDate){
                let newDate = new Date(e.serialDate);
                return e.serialNumber + ' ' + newDate.getDate()+' '+months[newDate.getMonth()]+' '+newDate.getFullYear()
            }else{
                return e.serialNumber
            }
        }).join("/");
        newSerial.forEach((nS) => {
            serials.findIndex(s => s.id === nS.id && nS.serialNumber === s.serialNumber) === -1?originalSerials.push(nS):originalSerials[serials.findIndex(s => s.id === nS.id && nS.serialNumber === s.serialNumber)] = nS;
        });
        tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].statusColor = (newSerial.filter(e=>e.isActive).length === tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].quantity?'Green':newSerial.filter(e=>e.isActive).length < tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].quantity?'Yellow':newSerial.filter(e=>e.isActive).length > tempSnaiV[snaiV.findIndex(s => s.id === rowData.id)].quantity?'Red':'White');
        setSerials(originalSerials);
        setSnaiV(tempSnaiV);
    };
    console.log('projectNumberSearch', projectNumberSearch);
    return (
        <>
        <Box display="flex">
            <Box p={1}>
                <TextField
                    label={t("projectNumLabel")}
                    variant="outlined"
                    size="small"
                    value={projectNumberSearch}
                    onChange={(e) => setProjectNumberSearch(e.target.value || "")}
                    onKeyDown={(e) => {
                        if(e.key === 'Enter') {                            
                            Navigate(`${baseURL}/project/${projectNumberSearch}`);                            
                        }}}
                />
            </Box>
            <Box p={1}>
                <Button variant="contained" color="primary" disabled={projectNumberSearch.length <= 0} onClick={() => {
                    Navigate(`${baseURL}/project/${projectNumberSearch}`);
                    
                }}>{t("searchButton")}
                </Button>
            </Box>
        </Box>            
            <CAETable
                stickyHeader
                isLoading={isLoading}
                pagination
                defaultRowsPerPage={10}
                excelExtractProperties={{
                    fileName: `SNAI-${String(projectNumberSearch)}-${new Date().toDateString()}`,
                    type: "filtered",
                  }}
                properties={[
                    { key: "id", title: "ID", isHidden: true },
                    
                    { key: "statusColor", title: t("statusColor"), 
                        render: (statusColor ) =>                         
                        <Box bgcolor={`${statusColor}`} color={`${statusColor}.contrastText`} textAlign="center" p={0.75}>{statusColor}</Box>
                    },
                    { key: "itemNumber", title: t("itemNumber"), isSortable: true },
                    { key: "projectNumber", title: t("projectNumber"), isSortable: true },
                    { key: "description", title: t("description"), isSortable: true },
                    { key: "nextAssyDescription", title: t("nextAssyDescription"), isSortable: true },
                    { key: "mfgParts", title: t("mfgParts"), isSortable: true },
                    { key: "quantity", title: t("quantity"), isSortable: true },
                    { key: "Edit", title: t("edit"), isSortable: false, 
                        render: (_, rowData) => 
                            <EditButton isAdmin={isAdmin} handleRefresh={handleRefresh} serials={serials} rowData={rowData as SnaiV} /> 
                    },
                    { key: "isHott", title: t("isHott"), isSortable: true, render: (isHott) => <Checkbox size={"small"} disabled checked={isHott} /> },
                    { key: "isPo", title: t("isPo"), isSortable: true, render: (isPo) => <Checkbox size={"small"} disabled checked={isPo} /> },
                    { key: "serialNumbers", title: t("serialNumbers"), isSortable: true },
                    { key: "procurementApproach", title: t("procurement"), isSortable: true },
                    { key: "acmUpdated", title: t("acmUpdated"), isSortable: true, type: "date"  },
                    { key: "updatedByName",title:t('updatedByName') },
                ]}
                rows={snaiV}
                
            />
        </>
    )
};
export default SNAI;
